const RECENT_PAGES_KEY = 'dorami.recentPages';
export const MAX_RECENT_PAGES = 5;

export const pushRecentPage = (paths, path, max = MAX_RECENT_PAGES) =>
	[path, ...paths.filter((item) => item !== path)].slice(0, max);

export const readRecentPages = () => {
	try {
		const stored = JSON.parse(window.localStorage.getItem(RECENT_PAGES_KEY));
		return Array.isArray(stored) ? stored.filter((item) => typeof item === 'string') : [];
	} catch {
		return [];
	}
};

export const recordRecentPage = (path) => {
	try {
		window.localStorage.setItem(RECENT_PAGES_KEY, JSON.stringify(pushRecentPage(readRecentPages(), path)));
	} catch {
		return;
	}
};
